import { useNavigate, useLocation } from 'react-router-dom';
import { useI18n, LOCALES, type Locale } from '../i18n';
import { switchLocalePath } from '../lib/localePath';

export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { locale, t } = useI18n();
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();

  const switchTo = (code: Locale) => {
    if (code === locale) return;
    navigate(`${switchLocalePath(pathname, code)}${search}${hash}`);
  };

  return (
    <div
      className={`lang-switch ${className}`}
      role="group"
      aria-label={t.lang.label}
    >
      {LOCALES.map((code) => {
        const active = locale === code;
        const name = t.lang[code as Locale];
        return (
          <button
            key={code}
            type="button"
            data-cursor
            className="lang-switch__btn mono-label"
            aria-pressed={active}
            aria-label={`${t.lang.label}: ${name}`}
            onClick={() => switchTo(code)}
          >
            {code.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
